import { Box, ErrorIcon, Export, TextBlock } from "@bcc-ui/ui-components";
import classNames from "classnames";
import * as React from "react";
import { useTranslation } from "react-i18next";
import { connect, ConnectedProps } from "react-redux";

import style from "components/import-file-dialog/import-file-dialog.scss";
import { StoreState } from "store";
import { resolveColor } from "utils/commonFunctions";

import testIds from "testIds.json";

const connector = connect((state: StoreState) => ({
    theme: state.themeReducer.theme,
}));

interface Props {
    failureMessage: string | JSX.Element;
    onUploadAnotherClicked: () => void;
    onDownloadFileClicked?: () => void;
    onClose?: () => void;
    licenseKeysUpload?: boolean;
}

const ImportKeysFailedDialog = (props: Props & ConnectedProps<typeof connector>) => {
    const { t } = useTranslation();

    const handleOkClick = () => {
        props.onUploadAnotherClicked();
    };
    return (
        <Box columnLayout gap="Md">
            <Box
                columnLayout
                verticalAlignment="Center"
                horizontalAlignment="Center"
                gap="Xxxs"
                paddingLeft="Xxs"
                paddingRight="Xxs"
                className={classNames(style.importKeysFailedWrapper, style.boldenedText)}
                data-testid={testIds.common.importFileDialog.failedFileUploadArea.itself}
            >
                <ErrorIcon />
                <TextBlock disableBottomSpacing alignCenter>
                    {props.failureMessage}
                </TextBlock>
                <TextBlock alignCenter disableBottomSpacing>
                    {t("AssetManagement.upload.fileUploadModal.error.tryAgain")}
                </TextBlock>
                <button
                    className={style.selectFile}
                    onClick={handleOkClick}
                    data-testid={testIds.common.importFileDialog.failedFileUploadArea.tryAgainButton}
                >
                    {t("ImportOemSerialLicenseKeys.importOemSerialLicenseKeys.browseFiles")}
                </button>
            </Box>
            {props.licenseKeysUpload ? (
                <Box columnLayout gap="Xs">
                    {t("ImportOemSerialLicenseKeys.selectFile.sampleCsvFileMessage")}
                    <div
                        className={classNames(style.boldenedText, style.sampleCsvFileWrapper)}
                        onClick={props.onDownloadFileClicked}
                        data-testid={testIds.common.importFileDialog.sampleFileDownloadButton}
                    >
                        {t("ImportOemSerialLicenseKeys.selectFile.sampleCsvFileName")}
                        <Export color={resolveColor("--theme-primary")} />
                    </div>
                </Box>
            ) : null}
        </Box>
    );
};

export default connector(ImportKeysFailedDialog);
